import React from 'react'

export default class NumericSelect extends React.Component {
    constructor(props) {
        super(props);

        var mdColSize = 4;
        var smColSize = 6;
        var xsColSize = 12;
        var title = "Select a number:";
        var increment = 10;
        var numSelected = 0;
        var styles;

        if (this.props.mdColumnSize !== undefined) {
            mdColSize = this.props.mdColumnSize;
        } if (this.props.smColumnSize !== undefined) {
            smColSize = this.props.smColumnSize;
        } if (this.props.xsColumnSize !== undefined) {
            xsColSize = this.props.xsColumnSize;
        } if (this.props.title !== undefined) {
            title = this.props.title;
        } if (this.props.increment !== undefined) {
            increment = this.props.increment;
        } if (this.props.numSelected !== undefined) {
            numSelected = this.props.numSelected;
        } if (this.props.padding !== undefined) {
            styles = {
                padding: this.props.padding
            }
        }

        this.options = {
            columnSize: "col-md-" + mdColSize + " col-sm-" + smColSize + " col-xs-" + xsColSize,
            title: title,
            increment: increment,
            numSelected: numSelected,
            styles: styles
        }
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.numSelected === undefined) {
            this.options.numSelected = nextProps.numSelected;
        } else {
            this.options.numSelected = nextProps.numSelected;
        }

        if(nextProps.reload != undefined) {
            this.options.increment = nextProps.increment;
        }
    }

    render(){
        const options = this.options;
        return (
            <div class={options.columnSize} style={options.styles}>
                <small>{options.title}</small>
                <select class="form-control" value={options.numSelected} onChange={this.props.onChange}>
                    {[...Array(options.increment)].map(function(x, i){
                            return <option value={i} key={i}>
                            {i}
                        </option>
                    })}
                </select>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/helpers/General/NumericSelect.jsx